export default __webpack_public_path__ + "static/media/course_analyzing_service.1c3b4ae5.png";